import { Environment } from '../app/shared/models/environment'

export const environment: Environment = {
  production: true,
  name: 'dev',
  baseUrl: 'https://rpc-dev.leon-grosse.fr/rpc-api-rest',
  portailChantierUrl: 'https://portailchantier-dev.leon-grosse.fr',
  oauth: {
    clientId: '2k2kg4g5hf9j4qlsqs0esbe0ut',
    loginUrl: 'https://lguserpoolrpcdev.auth.eu-west-3.amazoncognito.com/oauth2/authorize',
    issuer: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_aUBIQ2Hj4',
    logoutUrl: 'https://lguserpoolrpcdev.auth.eu-west-3.amazoncognito.com/logout',
    tokenEndpoint: 'https://lguserpoolrpcdev.auth.eu-west-3.amazoncognito.com/oauth2/token',
    userInfoEndpoint: 'https://lguserpoolrpcdev.auth.eu-west-3.amazoncognito.com/oauth2/userInfo',
    jwks: {
      keys: [
        {
          alg: 'RS256',
          e: 'AQAB',
          kid: 'ccnWXMhoX1Jyns/I9UmBIXggFi4LcX+HJk4J2sIPjD4=',
          kty: 'RSA',
          n: 'vpIMxSaLGpIo3orH7kq1cHs4js9VrCiCcDRsZOBORiSdrKcDFxcl7uREc_rjNYmgJLJuHf2BrJkhcqxzIMoP-jMISrzXK1-m3gRmnEHw-1vlPjE5uWtsmL4CFZXc99CNekx0Rln42KxGh_ucZ62pJh8l9kHZ1xNgT_roEUifJqbFnZi2YSkGgzGP37-kngHuzWuCnD6is-z93IHl9RbqRLKszV3mwVZIwZiAfp62qJ2tse84uDtVWui3Lsk2zFIiXJCb6y54FPH9Wyxt_xxYMnO4XY5JkaT74Dp46OzWR3Gmp92Oaq4PKyKgFi-hKHMTGoQh2Dt40E6f7oDDbc_pZQ',
          use: 'sig',
        },
        {
          alg: 'RS256',
          e: 'AQAB',
          kid: 'V/XT+qUaJHyKyq5yHX13FMMJj8up21/kABgJ+zRI7rw=',
          kty: 'RSA',
          n: 'xJpSgSSVyFEnirabAb4FXak_cg2Uq6gd3QQhZE065kb0hKGnoYTJ4GmP26407T7rtdbY3GPzY-_Xg2xrcW5t-EwRn_Lbf_nwN6sAvtV4ygYLNJa-PpZAViH6shVyEWjyyFws5LMiI1wUWCoa3NeQTU5JE5ZrQjrxhbwiGo0KgW1aMdk6wC3c0mMPTtFw_38itaDpJLtANL9xqKh9JDF3JHC_3WIqgGT4PqQGGkIzePsdPQinxdS-BXyYVYrSWZlxwyeNx-k94K7-3ewnvoNaX_lvaGyt_phMs3VWQSmEOFvtyBBQB1Q22o3fkPfzE2jZgn4Fr8Xm6HwNnJTCQNVBVQ',
          use: 'sig',
        },
      ],
    },
  },
}
